import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { EmptyEmailTemplate } from "./EmptyEmailTemplate";
import { Form } from "./Form";
import { Table } from "./Table";
import { IEmailTemplate } from "../../models/BaseModel";
import useToggle from "../../hooks/useToggle";

export interface IModel {
    open: boolean,
    singleData: IEmailTemplate
}

export const EmailTemplate = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: EmptyEmailTemplate, open: false } as IModel);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyEmailTemplate, open: false })
    };

    return (
        <>
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>

            <Toast ref={toast} />
        </>
    );
}
